import React from 'react';
import Icon from '../atoms/Icon';

function ArrowUpCircleIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <g
        className='arrow-icon-background'
        fill='#69BD28'
        stroke='#000'
        stroke-width='2.41667'
        stroke-miterlimit='10'
      >
        <path d='M15.7083 30.2083C23.7165 30.2083 30.2083 23.7165 30.2083 15.7083C30.2083 7.70021 23.7165 1.20834 15.7083 1.20834C7.7002 1.20834 1.20833 7.70021 1.20833 15.7083C1.20833 23.7165 7.7002 30.2083 15.7083 30.2083Z' />
      </g>
      
      <g
        className='arrow-icon-color'
        fill='none'
        stroke='#fff'
        stroke-width='2.41667'
        stroke-miterlimit='10'
      >
        <path d='M15.7083 9.66667V24.1667' />
        <path d='M8.8206 15.7081L15.7081 8.8206L22.5956 15.7081' />
      </g>
    </Icon>
  );
}

export default React.forwardRef(ArrowUpCircleIcon);
